import EnvironmentProvider from './EnvironmentProvider'

export function random(seed: number) {
  const x = Math.sin(seed++) * 10000
  return x - Math.floor(x)
}

export type Banner = {
  smallPath: string
  bigPath: string
  href: string
}

export type Banners = {
  [key: string]: Banner
}

export type BannerProviderProps = { banners: Banner[] }

export const BANNERS: Banners = {
  sip: {
    smallPath: '/banners/DC_Banner_SIP_2.gif',
    bigPath: '/banners/DC_Banner_SIP_1.gif',
    href: 'https://educacionyfuturo.decidechile.cl',
  },
  colunga: {
    smallPath: '/banners/DC_Banner_Colunga_2.gif',
    bigPath: '/banners/DC_Banner_Colunga_1.gif',
    href: 'https://www.observatorioninez.org/mapa-ninez',
  },
}

export const differentNBanners = ({
  nBanners,
  usedBanners = [],
}: {
  usedBanners?: string[]
  nBanners: number
}) => {
  const banners = Object.keys(BANNERS)
  const filteredBanners = banners.filter((banner) => !usedBanners.includes(banner))
  // Random seed between 0 and 1
  const seed = Math.random()
  const x = Math.sin(seed + 1) * 10000
  const seed2 = x - Math.floor(x)
  const randomBanners = filteredBanners
    .sort(() => random(seed) - random(seed2 + Math.random()))
    .slice(0, nBanners)
  return randomBanners.map((banner) => BANNERS[banner])
}

const BannerProvider = ({ ...props }) => {
  const banners = differentNBanners({ nBanners: 2 })

  return (
    <EnvironmentProvider
      env={{ banners }}
      {...props}
    />
  )
}

export default BannerProvider
